/* eslint-disable */

import { Card, CardContent, Typography, Box, Stack, Chip } from "@mui/material";
import { MobXProviderContext, Observer } from "mobx-react";
import React from "react";
import { TwoWheeler, AccessTime } from "@mui/icons-material";
import { isEntregadorOnline } from "shared/entregadorUtils";

function ListaEntregadores(props) {
  const { mapaStore } = React.useContext(MobXProviderContext);

  // Função para obter status do entregador baseado nas entregas
  const getEntregadorStatus = (entregadorId, status) => {
    // Conta pedidos pendentes do entregador
    const pedidosPendentes = mapaStore.pedidosPendentes.filter(p =>
      p.entregador && p.entregador.EntregadorId === entregadorId
    ).length;

    // Conta pedidos a caminho do entregador
    const pedidosACaminho = mapaStore.pedidosACaminho.filter(p =>
      p.entregador && p.entregador.EntregadorId === entregadorId
    ).length;

    if (pedidosACaminho > 0) {
      return {
        label: `Em Entrega (${pedidosACaminho})`,
        color: '#FF9800', // Laranja
        tipo: 'ocupado'
      };
    }

    if (pedidosPendentes > 0) {
      return {
        label: 'Aguardando aceite',
        color: '#2196F3', // Azul
        tipo: 'aguardando'
      };
    }

    // Se status = 2 e sem pedidos, está voltando à loja
    if (status === 2) {
      return {
        label: 'Voltando à loja',
        color: '#9C27B0', // Roxo
        tipo: 'voltando'
      };
    }

    return {
      label: 'Disponível',
      color: '#4CAF50', // Verde
      tipo: 'disponivel'
    };
  };

  // Função para centralizar o mapa no entregador
  const centralizarNoEntregador = (entregador) => {
    if (mapaStore.mapAdapter && entregador.lat && entregador.lng) {
      mapaStore.mapAdapter.setView(entregador.lat, entregador.lng, 16); // Zoom mais próximo
    }
  };

  // Função para formatar a data de última localização
  const formatarDataLocalizacao = (dataString) => {
    if (!dataString || dataString.length !== 14) return 'Nunca';

    // Parse da string: "20251022110818" -> YYYY MM DD HH mm ss
    const year = parseInt(dataString.substr(0, 4));
    const month = parseInt(dataString.substr(4, 2)) - 1;
    const day = parseInt(dataString.substr(6, 2));
    const hour = parseInt(dataString.substr(8, 2));
    const minute = parseInt(dataString.substr(10, 2));

    const dataGeolocalizacao = new Date(year, month, day, hour, minute);
    const agora = new Date();
    const diferencaMs = agora - dataGeolocalizacao;
    const diferencaMinutos = Math.floor(diferencaMs / (1000 * 60));

    if (diferencaMinutos < 1) return 'Agora';
    if (diferencaMinutos < 60) return `${diferencaMinutos} min atrás`;

    const diferencaHoras = Math.floor(diferencaMinutos / 60);
    if (diferencaHoras < 24) return `${diferencaHoras}h atrás`;

    const diferencaDias = Math.floor(diferencaHoras / 24);
    return `${diferencaDias}d atrás`;
  };


  // Função para calcular tempo desde a mudança de status
  const calcularTempoDisponivel = (horarioMudancaStatus) => {
    if (!horarioMudancaStatus || horarioMudancaStatus.length !== 14) return null;

    // Parse da string: "20251028162901" -> YYYY MM DD HH mm ss
    const year = parseInt(horarioMudancaStatus.substr(0, 4));
    const month = parseInt(horarioMudancaStatus.substr(4, 2)) - 1;
    const day = parseInt(horarioMudancaStatus.substr(6, 2));
    const hour = parseInt(horarioMudancaStatus.substr(8, 2));
    const minute = parseInt(horarioMudancaStatus.substr(10, 2));
    const second = parseInt(horarioMudancaStatus.substr(12, 2));

    const dataMudanca = new Date(year, month, day, hour, minute, second);
    const agora = new Date();
    const diferencaMs = agora - dataMudanca;
    const diferencaMinutos = Math.floor(diferencaMs / (1000 * 60));

    return diferencaMinutos;
  };

  // Função para formatar o tempo disponível
  const formatarTempoDisponivel = (minutos) => {
    if (minutos === null || minutos < 0) return '';
    if (minutos < 1) return 'Agora';
    if (minutos < 60) return `${minutos}min`;

    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;
    if (minutosRestantes === 0) return `${horas}h`;
    return `${horas}h ${minutosRestantes}min`;
  };

  var height = window.innerHeight;

  return (
    <Observer>{() => {
      // Filtrar apenas entregadores ativos e com localização recente (últimas 2 horas)
      const entregadoresOnline = mapaStore.entregadores.filter(e =>
        e.ativo !== 0 &&
        e.lat &&
        e.lng &&
        isEntregadorOnline(e.dataUltimaGeoLocalizacao)
      );

      // Ordenar entregadores por prioridade
      const entregadoresOrdenados = [...entregadoresOnline].sort((a, b) => {
        const statusA = getEntregadorStatus(a.id, a.status);
        const statusB = getEntregadorStatus(b.id, b.status);

        // Prioridade de status: disponivel > aguardando > voltando > ocupado
        const prioridades = {
          'disponivel': 1,
          'aguardando': 2,
          'voltando': 3,
          'ocupado': 4
        };

        const prioA = prioridades[statusA.tipo] || 999;
        const prioB = prioridades[statusB.tipo] || 999;

        // Se os status forem diferentes, ordenar por prioridade
        if (prioA !== prioB) {
          return prioA - prioB;
        }

        // Se ambos estão disponíveis (status = 1), ordenar por tempo disponível (mais antigo primeiro)
        if (statusA.tipo === 'disponivel' && statusB.tipo === 'disponivel') {
          const tempoA = calcularTempoDisponivel(a.horarioMudancaStatus);
          const tempoB = calcularTempoDisponivel(b.horarioMudancaStatus);

          // Maior tempo primeiro (quem está esperando há mais tempo)
          return (tempoB || 0) - (tempoA || 0);
        }

        // Para outros status iguais, manter ordem atual
        return 0;
      });

      // Só renderiza se tiver entregadores online
      if (entregadoresOrdenados.length === 0) {
        return null;
      }

      return (
        <div style={{
          position: 'absolute',
          left: 'calc(30% - 24px)', // Encostado à direita da lista de pedidos (32px margin left + 32px margin right)
          bottom: '8px',
          width: '280px',
          maxHeight: '300px',
          zIndex: '1001'
        }}>
          <Card style={{ padding: 0, backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
            <CardContent style={{ padding: '8px' }}>
              <Stack direction="row" alignItems="center" spacing={1} style={{ paddingBottom: 8, borderBottom: '2px solid #eee' }}>
                <TwoWheeler style={{ fontSize: 18, color: '#4CAF50' }} />
                <Typography variant="subtitle2" fontWeight="bold" style={{ color: '#333', flex: 1 }}>
                  Online
                </Typography>
                <Chip
                  label={entregadoresOrdenados.length}
                  size="small"
                  style={{ backgroundColor: '#4CAF50', color: '#fff', height: '20px', fontSize: '11px' }}
                />
              </Stack>

              <Box sx={{
                maxHeight: '280px', // Altura para ~5 entregadores (56px cada = 280px)
                overflowY: 'auto',
                overflowX: 'hidden', // Impede scroll horizontal
                paddingTop: 1,
                '&::-webkit-scrollbar': {
                  width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#f1f1f1',
                  borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#888',
                  borderRadius: '10px',
                  '&:hover': {
                    backgroundColor: '#555',
                  }
                }
              }}>
                {entregadoresOrdenados.map((entregador) => {
                  // Pega apenas o primeiro nome
                  const primeiroNome = entregador.nome ? entregador.nome.split(' ')[0] : '';
                  const status = getEntregadorStatus(entregador.id, entregador.status);
                  const tempoDisponivel = calcularTempoDisponivel(entregador.horarioMudancaStatus);

                  return (
                    <Box
                      key={entregador.id}
                      onClick={() => centralizarNoEntregador(entregador)}
                      style={{
                        padding: '6px 8px',
                        marginBottom: '4px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '6px',
                        borderLeft: `4px solid ${entregador.cor || '#d8e580'}`,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                      }}
                      sx={{
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                          boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                        }
                      }}
                    >
                      <Stack spacing={0.5}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Typography variant="body2" fontWeight="bold" style={{ color: '#333', fontSize: '13px' }}>
                            {primeiroNome}
                          </Typography>
                          <Stack direction="row" alignItems="center" spacing={0.5}>
                            <Box
                              style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: formatarDataLocalizacao(entregador.dataUltimaGeoLocalizacao) === 'Agora' ? '#4CAF50' : '#FFC107'
                              }}
                            />
                            <Typography variant="caption" style={{ color: '#999', fontSize: '10px' }}>
                              {formatarDataLocalizacao(entregador.dataUltimaGeoLocalizacao)}
                            </Typography>
                          </Stack>
                        </Stack>

                        <Stack direction="row" alignItems="center" spacing={0.5}>
                          <Chip
                            label={status.label}
                            size="small"
                            style={{
                              backgroundColor: status.color,
                              color: '#fff',
                              height: '18px',
                              fontSize: '10px',
                              fontWeight: 'bold',
                              width: 'fit-content'
                            }}
                          />
                          {status.tipo === 'disponivel' && tempoDisponivel !== null && (
                            <Typography variant="caption" style={{ color: '#666', fontSize: '10px', fontStyle: 'italic' }}>
                              há {formatarTempoDisponivel(tempoDisponivel)}
                            </Typography>
                          )}
                        </Stack>
                      </Stack>
                    </Box>
                  );
                })}
              </Box>
            </CardContent>
          </Card>
        </div>
      );
    }}</Observer>
  );
}

export default ListaEntregadores;
